import Dexie from 'dexie';

const db = new Dexie( 'files' );
db.version( 1 ).stores( {
    items: '++id'
} );

export default db;
